/**
 * Voice Channel Indicator Component
 *
 * Shows who is currently in voice for a channel
 * Displays in Sidebar next to channel name
 */

import React from 'react';
import { useLiveKit } from '@/contexts/LiveKitContext';

interface VoiceChannelIndicatorProps {
  channelId: string;
}

export const VoiceChannelIndicator: React.FC<VoiceChannelIndicatorProps> = ({ channelId }) => {
  const { state } = useLiveKit();

  // Only show if there are participants in this channel's voice
  if (state.channelId !== channelId || state.participants.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-1 ml-2">
      <span className="text-green-500" title={`${state.participants.length} in voice`}>
        🔊
      </span>
      <span className="text-xs text-gray-500">{state.participants.length}</span>
    </div>
  );
};
